module.exports = __webpack_public_path__ + "img/pressions_mains_shiatsu.f33e53f3.webp";